<template>
  <div ref="cell" class="grid-view__cell">
    <div v-if="value" class="field-last-modified-by">
      <div class="field-last-modified-by__name background-color--light-gray">
        <span class="field-last-modified-by__name-text">
          <SearchHighlightedText
            :text="getCollaboratorName(value, $store)"
            :search-term="searchTerm"
          />
        </span>
      </div>
      <div class="field-last-modified-by__initials">
        {{ getCollaboratorNameInitials(value, $store) }}
      </div>
    </div>
  </div>
</template>

<script>
import collaboratorName from '@baserow/modules/database/mixins/collaboratorName'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldLastModifiedBy',
  components: { SearchHighlightedText },
  mixins: [collaboratorName],
  props: {
    value: {
      type: Object,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
